import React, { useState } from "react";

// Importing Components for Each Step
import EmergencyRegistration from ".././components/EmergencyRegistration";
import TriageAssessment from ".././components/TriageAssessment";
import EmergencyAdmission from ".././components/EmergencyAdmission";
import PostAdmitUpdate from ".././components/PostAdmitUpdate";
import OngoingMonitoring from ".././components/OngoingMonitoring";
import DischargeTransfer from ".././components/DischargeTransfer";

// Step Titles
const steps = [
  { id: 1, label: "Emergency Registration" },
  { id: 2, label: "Triage Assessment" },
  { id: 3, label: "Emergency Admission" },
  { id: 4, label: "Post-Admit Information" },
  { id: 5, label: "Ongoing Monitoring" },
  { id: 6, label: "Discharge/Transfer" },
];

const Emergency = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    // Collect data across steps
    emergencyRegistration: {},
    triageAssessment: {},
    emergencyAdmission: {},
    postAdmitUpdate: {},
    ongoingMonitoring: {},
    dischargeTransfer: {},
  });

  const handleNext = () => {
    if (currentStep < steps.length - 1) setCurrentStep(currentStep + 1);
  };

  const handlePrev = () => {
    if (currentStep > 0) setCurrentStep(currentStep - 1);
  };

  const handleDataUpdate = (stepKey, data) => {
    setFormData((prev) => ({
      ...prev,
      [stepKey]: { ...prev[stepKey], ...data },
    }));
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <EmergencyRegistration
            data={formData.emergencyRegistration}
            updateData={(data) =>
              handleDataUpdate("emergencyRegistration", data)
            }
          />
        );
      case 1:
        return (
          <TriageAssessment
            data={formData.triageAssessment}
            updateData={(data) => handleDataUpdate("triageAssessment", data)}
          />
        );
      case 2:
        return (
          <EmergencyAdmission
            data={formData.emergencyAdmission}
            updateData={(data) => handleDataUpdate("emergencyAdmission", data)}
          />
        );
      case 3:
        return (
          <PostAdmitUpdate
            data={formData.postAdmitUpdate}
            updateData={(data) => handleDataUpdate("postAdmitUpdate", data)}
          />
        );
      case 4:
        return (
          <OngoingMonitoring
            data={formData.ongoingMonitoring}
            updateData={(data) => handleDataUpdate("ongoingMonitoring", data)}
          />
        );
      case 5:
        return (
          <DischargeTransfer
            data={formData.dischargeTransfer}
            updateData={(data) => handleDataUpdate("dischargeTransfer", data)}
          />
        );
      default:
        return <EmergencyRegistration />;
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 p-6">
      {/* Step Navigation */}
      <div className="w-full max-w-4xl bg-white shadow rounded-lg p-4">
        <div className="flex items-center justify-between border-b pb-4">
          <h1 className="text-2xl font-semibold">{steps[currentStep].label}</h1>
          <span className="text-gray-500">
            Step {currentStep + 1} of {steps.length}
          </span>
        </div>

        {/* Current Step */}
        <div className="mt-6">{renderStep()}</div>

        {/* Navigation Buttons */}
        <div className="flex justify-between mt-6">
          <button
            onClick={handlePrev}
            disabled={currentStep === 0}
            className={`px-4 py-2 bg-blue-500 text-white rounded ${
              currentStep === 0 ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            Previous
          </button>
          {currentStep < steps.length - 1 && (
            <button
              onClick={handleNext}
              className="px-4 py-2 bg-blue-500 text-white rounded"
            >
              Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default Emergency;
